import createReducer from 'utils/createReducer';
import {
  SET_KYC_CONTACT_LIST_LOADING,
  SET_KYC_CONTACT_LIST_DATA,
  SET_KYC_CONTACT_DETAIL_LOADING,
  SET_KYC_CONTACT_DETAIL_DATA,
  CLEAR_KYC_CONTACT_DETAIL,
  SET_KYC_CONTACT_FILE_URL,
} from 'state/actionTypes';

const initialState = {
  isLoading: false,
  data: [],
  paging: { page: 1, size: 10, total: 0 },
  detail: {
    isLoading: false,
    data: null,
    // keyed by fileId; kept across CLEAR_KYC_CONTACT_DETAIL since fileIds
    // are globally unique, so a re-opened contact can reuse a resolved url
    fileUrls: {},
  },
};

export default createReducer(initialState, {
  [SET_KYC_CONTACT_LIST_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [SET_KYC_CONTACT_LIST_DATA]: (draft, { payload }) => {
    draft.data = payload.data;
    draft.paging = payload.paging;
  },
  [SET_KYC_CONTACT_DETAIL_LOADING]: (draft, { payload }) => {
    draft.detail.isLoading = payload.isLoading;
  },
  [SET_KYC_CONTACT_DETAIL_DATA]: (draft, { payload }) => {
    draft.detail.data = payload.data;
  },
  [CLEAR_KYC_CONTACT_DETAIL]: draft => {
    draft.detail.data = null;
  },
  [SET_KYC_CONTACT_FILE_URL]: (draft, { payload }) => {
    draft.detail.fileUrls[payload.fileId] = payload.url;
  },
});
